module.exports = __webpack_public_path__ + "img/city2.48e72780.png";